import { useNetworkExplorer } from '#/data/useNetworks';
import formatString from '#/utils/formatString';
import { ExternalLink } from 'lucide-react';
import Link from 'next/link';
import { useMemo } from 'react';
import { Button } from './ui/button';

interface Props {
  symbol?: string;
  address?: string;
}

export default function NetworkAccountExplorer({ symbol, address }: Props) {
  const explorer = useNetworkExplorer(symbol);
  const href = useMemo(
    () => formatString(explorer, { address }),
    [explorer, address]
  );
  return (
    <Button variant="secondary" size="sm" asChild>
      <Link href={href ?? ''} target="_blank" rel="noreferrer" prefetch={false}>
        <ExternalLink className="w-4 h-4 mr-2" />
        View on Explorer
      </Link>
    </Button>
  );
}
